import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession, setToken } from "../../lib/api";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const sessionId = decodeURIComponent(match[1]);
    exchangeSession(sessionId)
      .then((data) => {
        if (data.session_token) setToken(data.session_token);
        window.history.replaceState(null, "", window.location.pathname);
        if (data.is_admin) navigate("/dashboard", { state: { user: data } });
        else navigate("/login", { state: { denied: true } });
      })
      .catch(() => setError("Sign-in failed. Please try again."));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] grid place-items-center text-white">
      <div className="text-center">
        {error ? (
          <p className="text-red-400 font-display uppercase text-xl">{error}</p>
        ) : (
          <>
            <Loader2 className="animate-spin text-[#7CB518] mx-auto" size={40} />
            <p className="mt-4 uppercase tracking-[0.3em] text-xs text-white/60">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
};
